import { authorization } from 'Module/Auth/Auth'
import { useWrappedPosthog } from 'Components/PostHogProvider/hooks'
import { AnalyticsEventEmitter } from 'Utils/Analytics/AnalyticsEventEmitter'
import { CAMPAIGN_ENUM_TO_CHANNEL_MAP } from 'shared/constants'

const usePosthogAnalyticsCampaignEmptyState = () => {
  const posthog = useWrappedPosthog()

  const emitAnalyticsEvent = option => {
    const channel = CAMPAIGN_ENUM_TO_CHANNEL_MAP[option]
    const user = authorization.getUser()
    const eventEmitter = new AnalyticsEventEmitter(posthog)
    eventEmitter.run({
      eventName: 'Clicked on CTA campaign empty state page',
      userId: user.id,
      clientName: user.client.name,
      additionalPayload: {
        channel: channel,
      },
    })
  }
  return { emitAnalyticsEvent }
}

export default usePosthogAnalyticsCampaignEmptyState
